import Media from 'react-media';
import { withTheme } from 'emotion-theming';

const HiddenOnLargeScreen = ({ children, theme }) => (
  <Media query={`(max-width: ${theme.breakpoints[1]})`}>{(matches) => (matches ? children : null)}</Media>
);

export default withTheme(HiddenOnLargeScreen);
